export const ALL_JOBS_REQUEST = "ALL_JOBS_REQUEST";
export const ALL_JOBS_SUCCESS = "ALL_JOBS_SUCCESS";
export const ALL_JOBS_FAIL = "ALL_JOBS_FAIL";

export const JOBS_DETAILS_REQUEST = "JOBS_DETAILS_REQUEST";
export const JOBS_DETAILS_SUCCESS = "JOBS_DETAILS_SUCCESS";
export const JOBS_DETAILS_FAIL = "JOBS_DETAILS_FAIL";

export const ADMIN_JOBS_REQUEST = "ADMIN_JOBS_REQUEST";
export const ADMIN_JOBS_SUCCESS = "ADMIN_JOBS_SUCCESS";
export const ADMIN_JOBS_FAIL = "ADMIN_JOBS_FAIL";

export const UPDATE_JOBS_REQUEST = "UPDATE_JOBS_REQUEST";
export const UPDATE_JOBS_SUCCESS = "UPDATE_JOBS_SUCCESS";
export const UPDATE_JOBS_RESET = "UPDATE_JOBS_RESET";
export const UPDATE_JOBS_FAIL = "UPDATE_JOBS_FAIL";

export const DELETE_JOBS_REQUEST = "DELETE_JOBS_REQUEST";
export const DELETE_JOBS_SUCCESS = "DELETE_JOBS_SUCCESS";
export const DELETE_JOBS_RESET = "DELETE_JOBS_RESET";
export const DELETE_JOBS_FAIL = "DELETE_JOBS_FAIL";

export const NEW_JOBS_REQUEST = "NEW_JOBS_REQUEST";
export const NEW_JOBS_SUCCESS = "NEW_JOBS_SUCCESS";
export const NEW_JOBS_RESET = "NEW_JOBS_RESET";
export const NEW_JOBS_FAIL = "NEW_JOBS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
